import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import { Col, Row, Form, Input, Button, message, Radio } from "antd";
import { CardElement } from "../../components/Common";
import InputElement, {
  QC_ComplianceOnChange,
} from "../../components/Report/ReportInputElement";
import {
  useGetProjectReportCategories,
  useReportUpdateReportList,
} from "../../hooks";

const BulkReportUpdate = (props) => {
  const history = useHistory();
  const [reports, setReports] = useState();
  const [project, setProject] = useState();
  const [documentTypes, setDocumentTypes] = useState([]);

  useEffect(() => {
    if (Array.isArray(history.location?.state?.reports)) {
      setReports(history.location?.state?.reports);
    }
    setProject(history.location?.state?.project);
    setDocumentTypes(history.location?.state?.documentTypes ?? []);
  }, []);

  const { data: projectReportCategories } = useGetProjectReportCategories(
    project,
    {
      enabled: !!project,
    },
  );

  const { mutate: updateReports, isLoading: isUpdating } =
    useReportUpdateReportList({
      onSuccess: () => {
        message.success("All Records updated successfully");
      },
      onError: (error) => {
        message.error(error?.response?.data?.message ?? "Server Error");
      },
    });

  const reportSubmitFn = (data) => {
    const apiData = [...reports];
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined) {
        for (let index = 0; index < apiData.length; index++) {
          apiData[index][key] = data[key];
        }
      }
    });
    updateReports(apiData);
  };

  const {
    control,
    handleSubmit,
    reset,
    resetField,
    watch,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({});

  return (
    <CardElement
      title="Advanced Report Management"
      showClose
      onClose={() => history.push("/report-management/bulk")}
    >
      <div
        style={{
          maxWidth: "1200px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Form wrapperCol={{ span: 24 }} labelCol={{ span: 24 }}>
          <Row gutter={[16, 16]}>
            <Col lg={8} md={8} sm={24}>
              <Form.Item label="Report Name">
                <Input
                  value={history.location?.state?.reportName ?? ""}
                  disabled
                />
              </Form.Item>
              <Form.Item label="PMS Report Name">
                <Controller
                  name="PMSReportName"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="PMSReportName"
                      field={field}
                      reportCategories={projectReportCategories ?? []}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Report Frequency">
                <Input
                  value={history.location?.state?.frequency ?? ""}
                  disabled
                />
              </Form.Item>
              <Form.Item label="Report Category">
                <Controller
                  name="report_category"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="report_category"
                      field={field}
                      reportCategories={projectReportCategories ?? []}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Signature Type">
                <Controller
                  name="signature_type"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="signature_type"
                      field={field}
                      setValue={setValue}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Report Order">
                <Controller
                  name="ReportOrder"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="ReportOrder"
                      field={field}
                      setValue={setValue}
                      watch={watch}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Signature Mandatory">
                <Controller
                  name="SignatureMandatory"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Radio.Group onChange={onChange} value={value}>
                      <Radio value={true}>true</Radio>
                      <Radio value={false}>false</Radio>
                    </Radio.Group>
                  )}
                />
              </Form.Item>
              <Form.Item label="Smart Scan">
                <Controller
                  name="smart_scan_type"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="smart_scan_type"
                      field={field}
                      setValue={setValue}
                      watch={watch}
                      getValues={getValues}
                      inputProps={{ allowClear: true }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Submission Method">
                <Controller
                  name="SourceType"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="SourceType"
                      field={field}
                      inputProps={{ allowClear: true }}
                    />
                  )}
                />
              </Form.Item>
            </Col>
            <Col lg={8} md={8} sm={24}>
              <Form.Item label="Generate Redact Files">
                <Controller
                  name="enable_redaction"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    // <InputElement dataIndex="enable_redaction" field={field} />
                    <Radio.Group onChange={onChange} value={value}>
                      <Radio value={true}>true</Radio>
                      <Radio value={false}>false</Radio>
                    </Radio.Group>
                  )}
                />
              </Form.Item>
              <Form.Item label="Generate Flat Files">
                <Controller
                  name="export_flat_files"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    // <InputElement dataIndex="export_flat_files" field={field} />
                    <Radio.Group onChange={onChange} value={value}>
                      <Radio value={true}>true</Radio>
                      <Radio value={false}>false</Radio>
                    </Radio.Group>
                  )}
                />
              </Form.Item>
              <Form.Item label="Split Reports By Sub Header Type">
                <Controller
                  name="split_by_sub_header"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="split_by_sub_header"
                      field={field}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Document Type">
                <Controller
                  name="document_type"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="document_type"
                      field={field}
                      documentTypes={documentTypes}
                      // inputProps={{ allowClear: true }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="myDocs Report Type">
                <Controller
                  name="mydocs_report_type"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="mydocs_report_type"
                      field={field}
                      inputProps={{ allowClear: true }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Business Date">
                <Controller
                  name="business_date"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="business_date"
                      field={field}
                      inputProps={{ disabled: true }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Subjects">
                <Controller
                  name="emailSubjects"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="emailSubjects"
                      field={field}
                      watch={watch}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="File Names">
                <Controller
                  name="filenames"
                  control={control}
                  render={({ field }) => (
                    <InputElement dataIndex="filenames" field={field} />
                  )}
                />
              </Form.Item>
              <Form.Item label="File Extension">
                <Controller
                  name="FileExtension"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="FileExtension"
                      field={field}
                      getValues={getValues}
                    />
                  )}
                />
              </Form.Item>
            </Col>
            <Col lg={8} md={8} sm={24}>
              <Form.Item label="File Mapping Name">
                <Controller
                  name="FileMappingName"
                  control={control}
                  render={({ field }) => (
                    <InputElement dataIndex="FileMappingName" field={field} />
                  )}
                />
              </Form.Item>
              <Form.Item label="Report Name Matching Condition">
                <Controller
                  name="report_name_matching_condition"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="report_name_matching_condition"
                      field={field}
                      inputProps={{ allowClear: true }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="QC Ignored Report">
                <Controller
                  name="QC_IgnoredReport"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Radio.Group
                      onChange={QC_ComplianceOnChange(
                        onChange,
                        "QC_IgnoredReport",
                        "",
                        getValues,
                        setValue,
                      )}
                      value={value}
                    >
                      <Radio value={true}>true</Radio>
                      <Radio value={false}>false</Radio>
                    </Radio.Group>
                    // <InputElement
                    //   dataIndex="QC_IgnoredReport"
                    //   field={field}
                    //   watch={watch}
                    //   getValues={getValues}
                    //   setValue={setValue}
                    // />
                  )}
                />
              </Form.Item>
              <Form.Item label="Compliance">
                <Controller
                  name="ComplianceEnabled"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Radio.Group
                      onChange={QC_ComplianceOnChange(
                        onChange,
                        "ComplianceEnabled",
                        "",
                        getValues,
                        setValue,
                      )}
                      value={value}
                      {
                        // may need to re-check, input can be disabled while value set to true
                        ...(watch(`shedule_type`) == "AsNeeded"
                          ? { disabled: true }
                          : {})
                      }
                    >
                      <Radio value={true}>true</Radio>
                      <Radio value={false}>false</Radio>
                    </Radio.Group>
                    // <InputElement
                    //   dataIndex="ComplianceEnabled"
                    //   field={field}
                    //   watch={watch}
                    //   getValues={getValues}
                    //   setValue={setValue}
                    // />
                  )}
                />
              </Form.Item>
              <Form.Item label="Activation Date">
                <Controller
                  name="activation_date"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="activation_date"
                      field={field}
                      inputProps={{ style: { width: "100%" } }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Deactivation Date">
                <Controller
                  name="deactivation_date"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="deactivation_date"
                      field={field}
                      watch={watch}
                      getValues={getValues}
                      setValue={setValue}
                      inputProps={{ style: { width: "100%" } }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Signature Activation Date">
                <Controller
                  name="signature_activation_date"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="signature_activation_date"
                      field={field}
                      watch={watch}
                      getValues={getValues}
                      setValue={setValue}
                      inputProps={{ style: { width: "100%" } }}
                    />
                  )}
                />
              </Form.Item>
              <Form.Item label="Signature Deactivation Date">
                <Controller
                  name="signature_deactivation_date"
                  control={control}
                  render={({ field }) => (
                    <InputElement
                      dataIndex="signature_deactivation_date"
                      field={field}
                      watch={watch}
                      getValues={getValues}
                      setValue={setValue}
                      inputProps={{ style: { width: "100%" } }}
                    />
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="center">
            <Col lg={8} md={8} sm={24}>
              <Row gutter={[16, 16]}>
                <Col lg={12} md={12} sm={12}>
                  <Button
                    style={{ width: "100%" }}
                    disabled={isUpdating}
                    onClick={() => reset()}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col lg={12} md={12} sm={12}>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    onClick={handleSubmit(reportSubmitFn)}
                    loading={isUpdating}
                  >
                    Update All
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    </CardElement>
  );
};

BulkReportUpdate.propTypes = {};

export default BulkReportUpdate;
